import React, { useState } from "react";
import CV from "../media/EyalCV.pdf";

function Navbar() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav className="nav">
      <div className="container nav__inner">
        <a className="nav__brand" href="#landingPage" onClick={close}>
          <span className="nav__name">EYAL BLUMENTAL EREZ</span>
          <span className="nav__role">Software Engineer · Full-Stack Developer</span>
        </a>
        <button
          className={`nav__burger${open ? " is-open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`nav__menu${open ? " is-open" : ""}`}>
          <a href="#about" onClick={close}>
            About
          </a>
          <a href="#showcase" onClick={close}>
            Showcase
          </a>
          <a href="#projects" onClick={close}>
            Projects
          </a>
          <a href="#contact" onClick={close}>
            Contact
          </a>
          <a className="nav__cv" href={CV} target="_blank" rel="noreferrer" onClick={close}>
            View CV
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
